// Constantes
export const PRIMARY_COLOR = "#23144D"
export const SECONDARY_COLOR = "#BF43AB"
export const SECONDARY_COLOR_DARK = '#7B286E';
export const THIRD_COLOR = "#254C7A"
export const TEXT_PRIMARY_COLOR = "#23144D"
export const TEXT_SECONDARY_COLOR = "#61688B"
export const TEXT_THIRD_COLOR = "#254C7A"
export const TEXT_SUCCESS_COLOR = "#43BF85"
export const SHADOW_PURPLE_COLOR = "#20174A";
export const SHADOW_GRAY_COLOR = "#61688B"
export const LIGHT_GRAY_COLOR = "#C0C0DE"
export const TABLE_BORDER_COLOR = "#E0E0E0";
export const GREEN = "#44bf86"
export const YELLOW = "#FFA700"
export const RED = "#FF444E"
export const WHITE_BACKGROUND = '#FFFFFF';
export const MODAL_BACKGROUND_COLOR = "#F7F6F9"
export const BORDER_CARD_COLOR = "#F5F4F7"
export const LIGHTEST_GRAY_COLOR = "#F0EFF2"
export const SNOW_COLOR = "#F4F5F7"
export const DISABLE_COLOR = 'rgba(192, 192, 222, 0.4)';
export const PRIMARY_COLOR_LIGHT = '#323172';
export const FONT_FAMILY_PRIMARY = "CircularStd-Book"
export const FONT_FAMILY_SECONDARY = "CircularStd-Medium"
export const FONT_FAMILY_TERTIARY = "CircularStd-Bold"
export const SPACING = 8

export const ALTURA_CABECALHO_LAYOUT = "64px"
export const LARGURA_MENU_LAYOUT = "81px";
export const CONTAINER_PAGINA_PADDING_TOP = "24px";
export const MARGIN_TOP_TOTAL_CONTEUDO_PAGINA = "88px";

// Mixins

const round2 = (n) => Math.round(n * 100) / 100

const em = (n) => round2(n) + "em"

const marginAndPaddingClasses = {
	".m-{i}": "margin",
	".mb-{i}": "marginBottom",
	".mt-{i}": "marginTop",
	".mr-{i}": "marginRight",
	".ml-{i}": "marginLeft",
	".p-{i}": "padding",
	".pb-{i}": "paddingBottom",
	".pt-{i}": "paddingTop",
	".pr-{i}": "paddingRight",
	".pl-{i}": "paddingLeft",
}

const generateNClasses = (name, number, calc) => {
	let classes = {}

	for (let i = 0; i <= number; i++) {
		let className = name.replace("{i}", i)
		classes[className] = calc(i)
	}
	return classes
}

const generateMarginAndPaddingClasses = (prefix) => {
	prefix = prefix || ""
	let classes = {}

	for (let cls in marginAndPaddingClasses) {
		let clsProp = marginAndPaddingClasses[cls]
		let tempClasses = generateNClasses(prefix + cls, 12, (i) => ({
			[clsProp]: spacing(i * 0.5),
		}))
		classes = {
			...classes,
			...tempClasses,
		}
	}
	return classes
}

export const spacing = (num) => (num ? num * SPACING + "px" : "0")

export const customGrid = (size) => ({
	maxWidth: size,
	flexBasis: size,
})

export const generateBorderDiv = (color, text) => {
	return {
		borderColor: color + " !important",
		borderWidth: "3px !important",
		borderRadius: 0,
		position: "relative",
		"&:before": {
			content: `'${text}'`,
			color: "#FFF",
			backgroundColor: color,
			fontSize: "0.75rem",
			padding: "1px 8px 0 8px",
			position: "absolute",
			top: "-3px",
			left: "-3px",
			borderBottomRightRadius: "4px",
			fontFamily: FONT_FAMILY_PRIMARY,
		},
	}
}

// Tema

export default {
	spacing: SPACING,

	palette: {
		secondary: { main: SECONDARY_COLOR },
		background: {
			default: "#F0F0F0",
		},
		text: {
			primary: TEXT_PRIMARY_COLOR,
			secondary: TEXT_SECONDARY_COLOR,
		},
	},

	typography: {
		fontFamily: FONT_FAMILY_PRIMARY,

		h1: {
			fontWeight: "bold",
			fontSize: "2.125rem",
			color: TEXT_PRIMARY_COLOR,
			fontFamily: FONT_FAMILY_TERTIARY,
		},
		h2: {
			fontWeight: "bold",
			fontSize: "1.625rem",
			color: TEXT_PRIMARY_COLOR,
		},
		h3: {
			fontWeight: "bold",
			fontSize: "1.5rem",
			color: TEXT_PRIMARY_COLOR,
		},
		h4: {
			fontWeight: "bold",
			fontSize: "1.25rem",
			color: TEXT_PRIMARY_COLOR,
		},
		h5: {
			fontWeight: "bold",
			fontSize: "1rem",
			color: TEXT_PRIMARY_COLOR,
			fontFamily: FONT_FAMILY_TERTIARY,
		},
		h6: {
			fontWeight: "bold",
			fontSize: "0.75rem",
			color: TEXT_PRIMARY_COLOR,
		},
		subtitle1: {
			fontSize: "0.75rem",
			color: TEXT_SECONDARY_COLOR,
			fontFamily: FONT_FAMILY_SECONDARY,
			lineHeight: 1.5,
		},
		body1: {
			fontSize: "1rem",
			color: TEXT_SECONDARY_COLOR,
			fontFamily: FONT_FAMILY_PRIMARY,
		},
		body2: {
			fontSize: "0.875rem",
			color: TEXT_SECONDARY_COLOR,
			fontFamily: FONT_FAMILY_PRIMARY,
		},
		caption: {
			fontSize: "0.75rem",
			fontWeight: "unset",
			color: TEXT_SECONDARY_COLOR,
			fontFamily: FONT_FAMILY_PRIMARY,
		},
	},
	overrides: {
		MuiTypography: {
			root: {
				...generateNClasses("&.gutter-bottom-{i}", 6, (i) => ({
					marginBottom: em(i * 0.35),
				})),
				"&.italico": {
					fontStyle: "italic",
				},
			},
		},
		MuiTable: {
			root: {
				backgroundColor: "#FFFFFF",

				"&.sem-bordas .MuiTableCell-root": {
					border: 0,
				},

				"& .MuiTableCell-head": {
					fontFamily: FONT_FAMILY_PRIMARY,
					backgroundColor: "#FFFFFF",
				},
			},
		},
		MuiTab: {
			root: {
				fontFamily: FONT_FAMILY_SECONDARY,
			},
		},
		MuiDialog: {
			paper: {
				margin: "10px",
				backgroundColor: "#FFFFFF",
			},
		},
		MuiButton: {
			root: {
				fontSize: "16px",
			},
		},
		MuiTableCell: {
			root: {
				"&.spacing-1": {
					padding: "14px 8px 14px 8px",
				},
			},
			head: {
				fontSize: "0.75rem",
				fontFamily: FONT_FAMILY_SECONDARY,
				color: TEXT_SECONDARY_COLOR,
				lineHeight: 1.25,
			},
			body: {
				fontSize: "14px",
				color: SHADOW_GRAY_COLOR,

				"&.body-1": {
					color: TEXT_PRIMARY_COLOR,
				},
			},
			sizeSmall: {
				padding: `0px ${spacing(1)} 0px ${spacing(1)}`,
			},
		},
		MuiTableRow: {
			root: {
				height: "48px",
			}
		},
		MuiTablePagination: {
			toolbar: {
				width: "10px",
			},
			caption: {
				fontSize: "16px",
			},
		},
		MuiGrid: {
			root: {
				...generateMarginAndPaddingClasses("&.MuiGrid-item."),
				"&.MuiGrid-item.relative": {
					position: "relative",
				},
			},
		},
		MuiListItem: {
			root: {
				alignItems: "unset",
			},
		},
		MuiInput: {
			underline: {
				"&.input-small .MuiInput-input": {
					paddingBottom: 0,
					paddingTop: 0,
					marginTop: "-2px",
					"&:before": {
						marginBottom: "-2px",
					},
				},
				"&.input-secondary": {
					color: SECONDARY_COLOR,
					"&:before, &:hover:not(.Mui-disabled):before, &:after": {
						borderColor: SECONDARY_COLOR,
					},
				},
			},
		},
		MuiBackdrop: {
			root: {
				backgroundColor: "rgba(192, 192, 222, 0.4)",
			},
		},

		MuiDivider: {
			root: {
				...generateMarginAndPaddingClasses("&"),
			},
		},
		MuiSlider: {
			marked: {
				...generateMarginAndPaddingClasses("&"),
			},
		},
		MuiSelect: {
			select: {
				"&:focus": {
					backgroundColor: "inherit !important"
				}
			}
		},
		MuiTooltip: {
			tooltip: {
				fontSize: '12px',
				fontFamily: "Raleway Regular",
				color: 'white',
				backgroundColor: '#333333',
			},
		},
	},
	global: {
		...generateMarginAndPaddingClasses(),

		".text-overflow-ellipsis": {
			textOverflow: "ellipsis",
			overflow: "hidden",
			whiteSpace: "nowrap",
		},
		".texto-successo": {
			color: TEXT_SUCCESS_COLOR,
		},
		".hover-icone": {
			"&:hover": {
				stroke: SECONDARY_COLOR,
				cursor: "pointer",
			},
		},
		".hover-texto": {
			"&:hover": {
				color: SECONDARY_COLOR,
				cursor: "pointer",
			},
		},
		".pointer": {
			cursor: "pointer",
		},
		".icone-pequeno": { height: "18px", width: "18px" },
		".icone-medio": { height: "22px", width: "22px" },
		".icone-grande": { height: "48px", width: "48px" },
		".italic": {
			fontStyle: "italic",
		},
		".underline": {
			textDecoration: "underline",
		},
		".bold": {
			fontWeight: "bold",
		},
		".float-right": {
			display: "block",
			float: "right",
		},
		".float-left": {
			display: "block",
			float: "left",
		},
		"h4 .texto-centralizado-vertical": {
			lineHeight: "1.25rem",
			verticalAlign: "middle"
		},
		".botao-grande": {
			height: "56px",
			width: "200px",
		},
		".container-pagina": {
			flexGrow: 1,
			paddingLeft: spacing(3),
			paddingTop: CONTAINER_PAGINA_PADDING_TOP,
			paddingRight: spacing(3),
			width: "100%",
			"& label.Mui-focused": {
				color: SECONDARY_COLOR + " !important",
			},
			"& .Mui-focused fieldset": {
				borderColor: SECONDARY_COLOR + " !important",
			}
		},
		".largura-maxima": {
			width: "100%",
		},
		".rodape-largura-maxima": {
			position: "absolute",
			bottom: 0,
			left: LARGURA_MENU_LAYOUT,
			width: `calc(100% - ${LARGURA_MENU_LAYOUT})`
		},
		".texto-grande, .MuiInputBase-input.texto-grande": {
			fontWeight: "bold",
			fontSize: "1.25rem",
			lineHeight: 1,
		},
		".container-modo-edicao": {
			...generateBorderDiv(SECONDARY_COLOR, "Modo Edição"),
		},

		".aviso-indicador": {
			display: "inline-block",
			borderRadius: "50%",
			width: "8px",
			height: "8px",
			verticalAlign: "inherit",
		},
		".desabilitar-selecao-texto": {
			userSelect: "none" /* Chrome and Opera */,
			webkitUserSelect: "none" /* Safari */,
			khtmlUserSelect: "none" /* Konqueror HTML */,
			mozUserSelect: "none" /* Firefox */,
			msUserSelect: "none" /* Internet Explorer/Edge */,
		},
		".posicaoAbsoluta": {
			position: "absolute",
		},
		".fundo-mobile .MuiBackdrop-root": {
			backgroundColor: "rgba(0, 0, 0, 0.6) !important"
		},
		".borda-padrao": {
			border: `1px solid ${LIGHT_GRAY_COLOR}`,
			borderRadius: "4px"
		},
		".link": {
			color: SECONDARY_COLOR,
			textDecoration: "none"
		}
	},
}
